export const shoppingCartItem = {
  bookUID: "",
  title: "",
  priceTHB: 0,
  coverImage: "",
  authorName: "",
  publisherName: "",
  creatorUID: ""
};
